//E:\SAUDIDUNES11\frontend\src\pages\RegisterPage.js
import styled from "styled-components";
import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background: linear-gradient(
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    );
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 768px) {
    padding: 20px 15px;
  }
`;

const Wrapper = styled.div`
  width: 40%;
  padding: 20px;
  background-color: white;

  @media only screen and (max-width: 768px) {
    width: 90%;
    max-width: 500px;
    padding: 20px 18px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  }
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 300;

  @media only screen and (max-width: 768px) {
    font-size: 20px;
    text-align: center;
    margin-bottom: 10px;
  }
`;

const Form = styled.form`
  display: flex;
  flex-wrap: wrap;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const Input = styled.input`
  flex: 1;
  min-width: 40%;
  margin: 20px 10px 0px 0px;
  padding: 10px;

  @media only screen and (max-width: 768px) {
    min-width: 100%;
    margin: 10px 0;
    padding: 12px;
    font-size: 16px; /* prevent iOS auto-zoom on focus */
  }
`;

const Button = styled.button`
  width: 40%;
  border: none;
  padding: 15px 20px;
  background-color: teal;
  color: white;
  cursor: pointer;

  @media only screen and (max-width: 768px) {
    width: 100%;
    margin-top: 15px;
    padding: 14px 20px;
    font-size: 16px;
    border-radius: 6px;
  }
`;

const RegisterPage = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    mobile: "",
    storeName: "",
  });

  useEffect(() => {
    document.title = "Create Account — SaudiDune";
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // 1) Create the account.
      await axios.post("/api/auth/register", {
        ...formData,
        role: "user",
      });

      // 2) Auto-login with the credentials the user just typed, so they
      //    end up on the home page already signed in — no manual
      //    "Sign In" step required.
      const loginRes = await axios.post("/api/auth/login", {
        email: formData.email,
        password: formData.password,
      });
      const { token, user } = loginRes.data;
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      alert("Account created successfully! You are now logged in.");
      navigate("/");
    } catch (err) {
      console.error(err);
      // If the register call failed vs the login call failed, give the
      // user a hint about which one.
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Registration failed.";
      alert(msg);
    }
  };

  return (
    <Container>
      <Wrapper>
        <Title>Create Account</Title>
        <Form onSubmit={handleSubmit}>
          <Input
            name="name"
            placeholder="Full Name"
            onChange={handleChange}
            required
          />
          <Input
            name="email"
            placeholder="Email"
            onChange={handleChange}
            required
          />
          <Input
            name="password"
            type="password"
            placeholder="Password"
            onChange={handleChange}
            required
          />
          <Input
            name="mobile"
            placeholder="Mobile Number"
            onChange={handleChange}
            required
          />
          <Input
            name="storeName"
            placeholder="Store Name"
            onChange={handleChange}
            required
          />
          <Button type="submit">CREATE</Button>
        </Form>
      </Wrapper>
    </Container>
  );
};

export default RegisterPage;
